<script lang="ts">
  import Dialog, { Content } from '@smui/dialog';
  import 'bootstrap/js/dist/modal';
  import { createEventDispatcher } from 'svelte';
  export let content: any = null;
  export let open = false;
  export let surfaceStyle: any =
    'width:48vw;height:70vh;min-height:70vh!;max-height:70vh;max-width: 48vw;border-radius: 24px;';
  const dispatch = createEventDispatcher();

  const closeHandler = () => {
    open = false;
    dispatch('close');
  };
</script>

{#if open && content}
  <Dialog
    bind:open
    aria-labelledby="dialog-title"
    surface$style={surfaceStyle}
    aria-describedby="dialog-content"
    on:SMUIDialog:closed={closeHandler}
    class="c_extrapopup"
  >
    <Content>
      <div class="d-flex flex-column c_highlights-content">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span class="c_icon_new c_icon_new--close close" aria-label="close" on:click={closeHandler}></span>
        {@html content}
      </div>
    </Content>
  </Dialog>
{/if}

<style lang="scss">
  .c_extrapopup {
    z-index: 10000 !important;
    justify-content: center;
    :global {
      .mdc-dialog__container {
        justify-content: flex-end !important;
        z-index: 10000;
        height: 100dvh;
        .mdc-dialog__surface {
          width: 655px !important;
          min-height: 100% !important;
          min-width: unset;
        }
      }
    }
  }
</style>
